import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getAffordaPortalFormByPortalUserId } from 'services/affordaPortalForms';
import { AppContext } from 'contexts/AppContext';
import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';
import { INITIAL_STATE } from './constants';
import QUERY_KEYS from 'constants/queryKeys';

const useAffordaPortalFormsQuery = ({ options } = {}) => {
  const abortControllerOptions = useAbortController();
  const { organizationId, propertyId } = useContext(AppContext);
  const { data: userProfile } = useUserProfileQuery();
  const { portalUserId } = userProfile ?? {};

  const queryKey = QUERY_KEYS.getAffordaPortalFormByPortalUserId({
    organizationId,
    propertyId,
    portalUserId,
  });

  const queryOptions = useMemo(
    () => ({
      refetchOnWindowFocus: false,
      placeholderData: INITIAL_STATE,
      enabled: Boolean(
        organizationId?.length && propertyId?.length && portalUserId?.length,
      ),
      ...options,
    }),
    [options, organizationId?.length, portalUserId?.length, propertyId?.length],
  );

  return useQuery(
    queryKey,
    async () => {
      const response = await getAffordaPortalFormByPortalUserId({
        organizationId,
        propertyId,
        portalUserId,
        options: abortControllerOptions,
      });
      if (typeof response === 'string') {
        return INITIAL_STATE;
      } else {
        return response;
      }
    },
    queryOptions,
  );
};

export default useAffordaPortalFormsQuery;
